<template>
  <div>
    <button @click="login">
      Hello
    </button>
    <div>
      {{ token }}
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'GoogleLogin',
  data() {
    return {
      token: 'No token yet',
    };
  },
  methods: {
    login() {
      this.$gAuth.getAuthCode()
        .then((authCode) => {
          // on success
          console.log(authCode);
          this.token = authCode;
          return this.$http.post('http://localhost:8005/auth_google', { code: authCode, redirect_uri: 'postmessage' });
        })
        .then((response) => {
          // after ajax
        })
        .catch((error) => {
          // on fail do something
        });
    },
  },
};
</script>
